<!-- <body>
<div class="login-box">
    <h2>Login</h2>
    <form   style="max-width: 320px;"  class="form-field-full">
       <div class="user-box">
        <input type="text"  name=""   pattern="[0-9]*" minlength="10" maxlength="10" required="">
        <label>Username</label>
      
    </div>
      <div class="user-box">
        <input type="password" name="" required="">
        <label>Password</label>
      </div>
      <a href="overview">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        Login
      </a>
    </form>
  </div>
</body> -->
<!-- <div *ngIf="fail_show" class="alert" [class.visible]="isVisible"> 
    {{fail_mgs}}
  </div> -->
<body>
    <div style="text-align: center; justify-self: center;">
<img src="../../assets/lectrix.png"  height="30px" style="margin-top: 60px;">
</div>    
<div class="login-box">
        <h2 style="color: #000">Welcome</h2>
        <form #loginForm="ngForm" class="form-field-full" (ngSubmit)="loginForm.valid && login(loginForm.value)">

            <mat-form-field  style="width: 100%;" appearance="outline">
                <mat-label style="font-family: 'Open Sans', sans-serif;color: #000;"> UserName
                </mat-label>
                <input  matInput #emailref="ngModel" [(ngModel)]="q.mobileNumber"  placeholder="Enter UserName" 
                     name="mobileNumber" appAutofocus required>
                    <mat-error *ngIf="emailref.hasError('required')">
                        UserName is required
                    </mat-error>
            </mat-form-field>


            <mat-form-field  style="width: 100%;" appearance="outline">
                <mat-label style="font-family: 'Open Sans', sans-serif;color: #000;">Password
                </mat-label>
                <input type="password" style="color: #000;" matInput type="password" [type]="hide ? 'password' : 'text'" #passwordref="ngModel"
                    [(ngModel)]="q.password" name="password" placeholder="Enter Password" required>
                <button mat-icon-button type="button" matSuffix (click)="hide = !hide"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" style="color: #000 ;">
                    <mat-icon style="margin-top: -12px;margin-left:-7px">{{hide ? 'visibility_off' : 'visibility'}}
                    </mat-icon>
                </button>
                <mat-error *ngIf="passwordref.hasError('required')">
                    Password is required
                </mat-error>

            </mat-form-field>

            <div *ngIf="fail_show" style="color:red ;padding-left: 5%">
                {{fail_mgs}}
            </div>
            <br>
            <!-- <button class="w-full" type="submit" mat-raised-button color="primary"
                            style="color: white;font-weight: bold; background-color: #f47a21;margin-top: 6%;font-family: 'Open Sans', sans-serif;">Login</button> -->
            <button type="submit" style="background-color: #61B741;"> <a style="color: #000;">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    Login
                </a>
            </button>
        </form>
    </div>
</body>
<div class="matero-col" fxFlex.gt-sm="30" fxFlex.gt-xs="30" style="text-align: center;">
</div>